import { useState, useEffect, useCallback } from 'react'
import { db } from '../lib/supabase'

export function useProducts() {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchProducts = useCallback(async () => {
    setLoading(true)
    const { data, error } = await db.getProducts()
    if (error) {
      setError(error)
    } else {
      setProducts(data)
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    fetchProducts()
  }, [fetchProducts])

  const createProduct = async (product) => {
    const { data, error } = await db.createProduct(product)
    if (!error && data) {
      setProducts(prev => [...prev, data])
    }
    return { data, error }
  }

  const updateProduct = async (id, updates) => {
    const { data, error } = await db.updateProduct(id, updates)
    if (!error && data) {
      setProducts(prev => prev.map(p => p.id === id ? data : p))
    }
    return { data, error }
  }

  return {
    products,
    loading,
    error,
    refetch: fetchProducts,
    createProduct,
    updateProduct,
  }
}

export default useProducts
